module.exports = __webpack_public_path__ + "img/empty-questions.cba09e75.svg";